import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useConceptSearch } from "@/contexts/ConceptSearchContext";
import {
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
} from "@/components/ui/command";
import { useConcepts } from "@/hooks/useConcepts";
import { routes } from "@/lib/routes";
import { stripLabelId } from "@/lib/conceptLabel";

export function ConceptSearchCommand() {
  const { open, setOpen, toggle } = useConceptSearch();
  const { data: concepts } = useConcepts();
  const navigate = useNavigate();

  useEffect(() => {
    const down = (e: KeyboardEvent): void => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        toggle();
      }
    };
    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, [toggle]);

  const handleSelect = (slug: string): void => {
    setOpen(false);
    navigate(routes.conceptDetail(slug));
  };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Search concepts..." />
      <CommandList>
        <CommandEmpty>No concepts found.</CommandEmpty>
        <CommandGroup heading="Concepts">
          {concepts
            ?.filter((c: { type: string }) => c.type !== "category")
            .map((c: { id: string; label: string; slug: string; type: string }) => (
              <CommandItem
                key={c.id}
                value={`${stripLabelId(c.label)} ${c.slug} ${c.id}`}
                onSelect={() => handleSelect(c.slug)}
              >
                <span className="truncate">{stripLabelId(c.label)}</span>
              </CommandItem>
            ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
